module.exports = __webpack_public_path__ + "img/dk.b4ba001c.svg";